import React from "react";

import { IconLinkButton } from "components";

export const LinkMoreInfo = ({ mixpanelText = "", children, dataTestId = "", color = "", href = "", className = "", theme = "", onClick = () => {} }) => (
  <div className={`${color} ${className}`}>
    <IconLinkButton iconType="info" dataTestId={dataTestId} onClick={onClick} mixpanelText={mixpanelText} text={children} href={href} theme={theme} />
  </div>
);

export default LinkMoreInfo;
